@if (type === "dashboard") {
} @else {
  <footer class="py-4 fs-7 bg-black text-white">
    <div
      class="container d-lg-flex justify-content-between flex-row-reverse gap-3 text-center text-sm-start"
    >
      <div class="d-sm-flex gap-2 gap-sm-3 justify-content-center mb-3 mb-lg-0">
        <div>
          <a
            [href]="'tel:' + rvsfDetails()?.rvsf_contact_mobile_no"
            class="text-white text-decoration-none"
            > {{ rvsfDetails()?.rvsf_contact_mobile_no }}</a
          >
        </div>
        <div>
          <a
            [href]="'mailto:' + rvsfDetails()?.rvsf_contact_email_id"
            class="text-white text-decoration-none"
            >{{ rvsfDetails()?.rvsf_contact_email_id }}</a
          >
        </div>
        <div>{{ rvsfDetails()?.landing_page_about_us_text }}</div>
      </div>
      <div class="d-sm-flex flex-row-reverse justify-content-center">
        <div class="d-flex justify-content-center gap-1">
          <span class="d-none d-sm-block">|</span>
          <a href="#" class="text-white text-decoration-none">Privacy Policy</a>
          <span>|</span>
          <a href="#" class="text-white text-decoration-none"
            >Terms of Service</a
          >
        </div>
        <div class="pe-sm-1"> © {{ currentYear }} {{ rvsfDetails()?.rvsf_legal_name }}. All rights reserved.</div>
      </div>
    </div>
  </footer>
}
